import {
  Component,
  OnInit,
  inject,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SelectItem } from '@openng/optimus-ui/api';
import {
  MultiSelectChangeEvent,
  MultiSelect,
} from '@openng/optimus-ui/multiselect';
import { AuthApiService } from 'src/app/services/api/auth-api.service';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-business-unit-filter',
  templateUrl: './business-unit-filter.component.html',
  styleUrls: ['./business-unit-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MultiSelect, FormsModule, TranslatePipe],
})
export class BusinessUnitFilterComponent implements OnInit {
  protected _authApi = inject(AuthApiService);

  businessUnits: SelectItem[] = [];
  selectedBusinessUnits: string[] = [];

  readonly selectedBusinessUnitsChanged = output<string[]>();

  ngOnInit(): void {
    this.businessUnits = this._authApi.getUserBusinessUnits().map((bu) => {
      return { label: bu.name, value: bu.id };
    });
    // Start with always having all of the user's available business units selected
    this.businessUnits.forEach((item) =>
      this.selectedBusinessUnits.push(item.value)
    );
  }

  handleBusinessUnitChange($event: MultiSelectChangeEvent) {
    this.selectedBusinessUnitsChanged.emit(this.selectedBusinessUnits);
  }
}
